/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Using transaction to deprecate legacy satchel actions */
import { transaction } from "owa-transaction";
import type TabViewState from "../store/schema/TabViewState";
import { type TabState } from "../store/schema/TabViewState";
import activateTab from "./activateTab";
import { mutatorAction } from "satcheljs";
import { getStore } from "../store/tabStore";

function getNextVisibleTab(tab: TabViewState): TabViewState | null {
    const tabs = getStore().tabs;
    const startIndex = Math.max(tabs.indexOf(tab), 0);
    const nextActiveTab = tabs.filter(t => t.id == tab.parentTabId && t.state == 1)[0];
    
    if (nextActiveTab) {
        return nextActiveTab;
    }
    
    for (let i = startIndex; i < tabs.length; i++) {
        if (tabs[i].state == 1) {
            return tabs[i];
        }
    }
    
    for (let i = startIndex - 1; i >= 0; i--) {
        if (tabs[i].state == 1) {
            return tabs[i];
        }
    }
    
    return null;
}

const minimizeTabMutator = mutatorAction("minimizeTab", (viewState: TabViewState) => {
    viewState.state = 1;
    viewState.blink = true;
});

const hideTabMutator = mutatorAction("hideTab", (viewState: TabViewState) => {
    viewState.state = 0;
});

export default function setTabIsShown(viewState: TabViewState, isShown: boolean): void {
    transaction(() => {
        switch (viewState.state) {
            case 0:
                if (isShown) {
                    minimizeTabMutator(viewState);
                }
                break;
            
            case 1:
            case 2:
            case 3:
                if (!isShown) {
                    const nextActiveTab = viewState.state == 2 && getNextVisibleTab(viewState);
                    
                    if (nextActiveTab) {
                        activateTab(nextActiveTab);
                    }
                    
                    hideTabMutator(viewState);
                }
                break;
        }
    });
}
